export const MIN_BAR_HEIGHT = 8;
export const MAX_BAR_WIDTH = 480;
export const MAX_BAR_WITH_IMAGE_WIDTH = 280;
export const VALUE_TEXT_HEIGHT = 48;
export const VALUE_TEXT_MARGIN = 16;
export const LABELS_HEIGHT = 96;

// margin top needed by the visualization
export const MIN_MARGIN_TOP = VALUE_TEXT_HEIGHT + VALUE_TEXT_MARGIN;

export const BAR_BOTTOM_RADIUS = 4;
export const BAR_TOP_LEFT_RADIUS = 4;
export const SMALL_BAR_RADIUS = 4;
export const getTopRightRadius = (width: number) => (width > 300 ? 32 : 24);

export const LOW_OPACITY = 0.2;
export const AVATAR_LOW_OPACITY = 0.8;
